import AuditionReducer from "./auditions";
import AuthReducer from "./auth";
import GeneralReducer from "./general";
import MediaReducer from "./media";
import NotificationReducer from "./notification";
import ProfileReducer from "./profile";
import UserReducer from "./user";

/**
 * @author Sarthak Sharma
 * @since 12-02-2024
 * @description to combine artist reducers
 */


const artistReducer = {
    artistAuthReducer: AuthReducer,
    artistGeneralReducer: GeneralReducer,
    artistAuditionReducer: AuditionReducer,
    artistProfileReducer: ProfileReducer,
    artistMediaReducer: MediaReducer,
    artistUserReducer: UserReducer,
    artistNotificationReducer: NotificationReducer
};

export default artistReducer;